import format from "date-fns/format";
import { TFunction } from "i18next";
import {
  ICellRendererParams,
  ValueGetterParams,
} from "@ag-grid-community/core";

import {
  getCommonColumnDefs,
  getCommonRenderers,
} from "fe-shared-transactions/src/helpers/transactionsGridConfig";

import { TypeRenderer } from "fe-shared-transactions/src/components/TransactionsDataGrid/renderers";
import { AssigneeRenderer, FlagsRenderer } from "../renderers";

export const getFormattedDate = (date?: string) =>
  format(new Date(date || Date.now()), "MMM d, yyyy");

export const getColumnDefs = (t: TFunction) => [
  {
    headerName: "",
    sortable: false,
    field: "selection",
    width: 30,
    minWidth: 30,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: false,
  },
  ...getCommonColumnDefs(t),
  {
    headerName: t("transactions.grid.cols.assignee"),
    colId: "assignee",
    valueGetter: (params: ValueGetterParams) => ({
      statusCode: params.data?.statusCode,
      assignee: params.data?.assignee,
      isValidating: params.data?.isValidating,
    }),
    minWidth: 200,
    cellRenderer: "assigneeRenderer",
    filter: "textFilter",
    floatingFilterComponent: "floatingTextFilter",
    floatingFilterComponentParams: {
      placeholder: t("transactions.grid.placeholder.assignee"),
      suppressFilterButton: true,
    },
  },
  {
    headerName: "",
    sortable: false,
    field: "flags",
    filter: "textFilter",
    floatingFilterComponent: "clearFilters",
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      id: "transactions-clear-filters-button",
    },
    width: 120,
    minWidth: 120,
    cellRenderer: "flagsRenderer",
  },
  {
    hide: true,
    colId: "hasManualFlag",
    filter: "textFilter",
  },
  {
    hide: true,
    colId: "hasAutoFlag",
    filter: "textFilter",
  },
  {
    hide: true,
    colId: "isPaperForm",
    filter: "textFilter",
  },
  {
    hide: true,
    colId: "isNotLinked",
    filter: "textFilter",
  },
];

export const getRenderers = (canAssign: boolean) => ({
  ...getCommonRenderers(),
  typeRenderer: (props: ICellRendererParams) =>
    TypeRenderer({ ...props, isStaffView: true }),
  assigneeRenderer: (props: ICellRendererParams) =>
    AssigneeRenderer({ ...props, canAssign }),
  flagsRenderer: FlagsRenderer,
});
